import React from 'react';
import { StepTypeIcon } from './StepTypeIcon';
export function PreferenceTestIcon(props) {
    return (React.createElement(StepTypeIcon, Object.assign({ bg: "pink4", color: "pink12" }, props),
        React.createElement("path", { d: "m29.8013 17.3824c-.4612-1.6227-1.7823-2.8815-3.4625-3.2991-1.8083-.3132-3.6517.3309-4.8393 1.6908-1.186-1.3625-3.0299-2.009-4.8393-1.6967-1.682.4183-3.0037 1.6798-3.4626 3.305-.4978 1.6035-.0387 3.3427 1.1922 4.5164l6.6993 5.9467c.232.206.5876.206.8195 0l6.7199-5.9656c1.2185-1.1729 1.6697-2.9032 1.1728-4.4975z" })));
}
